import React from 'react';
import styled from 'styled-components';
import Cards from 'components/Cards/Cards';

const ResourceHubFeaturedContent = ({ featuredContent }) => {
  const data = {
    title: undefined,
    linkTo: undefined,
    description: undefined,
    category: undefined,
    backgroundImage: undefined,
  };

  if (featuredContent?.__typename === 'ContentfulBlog') {
    let hub = 'blog';
    featuredContent?.tags?.find(tag => {
      if (tag === 'Covid19') hub = 'coronavirus';
    });
    data.linkTo = `/${hub}/${featuredContent?.slug}`;
    data.backgroundImage = featuredContent?.featuredImage?.fluid?.src;
  }

  data.title = featuredContent?.title;
  data.description = featuredContent?.excerpt?.excerpt;
  data.category = featuredContent?.category;

  return (
    <FeaturedContent className="featured-content-section">
      <Cards
        type="Image"
        bodyType="blog"
        sideCover={true}
        coverImage={featuredContent?.featuredImage}
        category={data.category}
        title={data.title}
        description={data.description}
        ctaTitle={'Learn more'}
        ctaLink={data.linkTo}
      />
    </FeaturedContent>
  );
};

export default ResourceHubFeaturedContent;

const FeaturedContent = styled.div`
  margin-top: 60px;
  &:hover {
    box-shadow: 0 8px 24px 8px rgba(160, 161, 188, 0.14) !important;
    top: -4px;
  }
  .side-card--image-wrapper {
    width: 70%;
    .gatsby-image-wrapper {
      height: 100%;
      @media (max-width: 1280px) {
        height: auto;
      }
    }
  }
  .side-card--card-wrapper {
    width: 31%;
    .industry-card--container .industry-card--content-container {
    }
    .ant-card-body {
      padding: 20px 32px !important;
      .industry-card--container {
        padding: 0px !important;
      }
    }
  }
  @media (max-width: 576px) {
    display: none;
  }
`;
